module.exports = __webpack_public_path__ + "static/img/jumper_mm-1.f6ad3be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/jumper_mm-1.svg
// module id = bOAw
// module chunks = 0